module.exports = __webpack_public_path__ + "img/vent.d3001ec9.svg";